import {
  NewCampaignFormData,
  NewCampaignInfluencerProfile,
} from "../CampaignInterface/NewCampaignInterface";

interface ValidationProps {
  formData: NewCampaignFormData;
  currentStep: number;
  checkArray?: number[];
  selectedPurpose: string[];
  startDate?: Date;
  endDate?: Date;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toast: any;
  setCurrentStep: (step: number) => void;
  setIsLoading: (loading: boolean) => void;
  generalState?: {
    setLoading: (loading: boolean) => void;
  };
  SelectedInfluencersWithCPI: NewCampaignInfluencerProfile[];
}

const validationRules = {
  1: [
    {
      condition: (props: ValidationProps) => props.selectedPurpose.length === 0,
      message: "Please select campaign goal",
    },
    {
      condition: (props: ValidationProps) =>
        !props.formData.collabInfo?.collabGoals,
      message: "Please select what you want to achieve",
    },
    {
      condition: (props: ValidationProps) =>
        !props.formData.collabInfo?.collabPlatform,
      message: "Please select platform",
    },
    {
      condition: (props: ValidationProps) =>
        !props.formData.collabInfo?.collabIndustry,
      message: "Please enter industry area",
    },
    {
      condition: (props: ValidationProps) =>
        !props.formData.collabInfo?.collabBuisnessType,
      message: "Please select business type",
    },
    {
      condition: (props: ValidationProps) => !props.startDate,
      message: "Please select start date",
    },
    {
      condition: (props: ValidationProps) => !props.endDate,
      message: "Please select end date",
    },
    //end date and start date should not be before today
    {
      condition: (props: ValidationProps) =>
        new Date(props.startDate).getTime() < new Date().getTime(),
      message: "Start date should not be before today",
    },
    {
      condition: (props: ValidationProps) =>
        new Date(props.endDate).getTime() < new Date(props.startDate).getTime(),
      message: "End date should not be before start date",
    },
    {
      condition: (props: ValidationProps) =>
        !props.formData.Budget.minBillAmount ||
        parseInt(props.formData.Budget.minBillAmount.toString()) < 1,
      message: "Please enter minimum budget",
    },
    {
      condition: (props: ValidationProps) =>
        !props.formData.Budget.maxBillAmount ||
        parseInt(props.formData.Budget.maxBillAmount.toString()) < 1,
      message: "Please enter maximum budget",
    },
    {
      condition: (props: ValidationProps) =>
        parseInt(props.formData.Budget.maxBillAmount?.toString() || "0") <
        parseInt(props.formData.Budget.minBillAmount?.toString() || "0"),
      message: "Minimum budget should not be greater than maximum budget",
    },
  ],
  2: [
    {
      condition: (props: ValidationProps) =>
        !props.formData.creatorInfo.minCreatorFollowers,
      message: "Please select min Influencer followers",
    },
    {
      condition: (props: ValidationProps) =>
        !props.formData.creatorInfo.maxCreatorFollowers,
      message: "Please select max Influencer followers",
    },
    {
      condition: (props: ValidationProps) => {
        const { maxCreatorFollowers, minCreatorFollowers } =
          props.formData.creatorInfo;
        return maxCreatorFollowers === '"More than 100k"'
          ? false
          : parseInt(minCreatorFollowers?.replace("k", "") || "0") >
              parseInt(maxCreatorFollowers?.replace("k", "") || "0");
      },
      message: "Minimum followers should be less than maximum followers",
    },
    {
      condition: (props: ValidationProps) =>
        !props.formData.postInfo?.postDrafts?.filter((i) => i?.status)?.[0]
          ?.postFormat?.length,
      message: "Please select Post Format",
    },
  ],
  // 3: [
  //   {
  //     condition: (props: ValidationProps) =>
  //       !props?.SelectedInfluencersWithCPI?.every(
  //         (item) => item?.priceByBrand > 99
  //       ),
  //     message: "minimum custom commercial is ₹100",
  //   },
  // ],
  4: [
    {
      condition: (props: ValidationProps) =>
        !props.formData.productInfo.productName,
      message: "Please enter product name",
    },
    {
      condition: (props: ValidationProps) =>
        !props.formData.postInfo?.postDrafts
          ?.filter((i) => i?.status)
          ?.every((draft) => draft.postFormat?.length),
      message: "Please fill in all required fields to continue",
    },
    {
      condition: (props: ValidationProps) =>
        !props.formData.postInfo?.postDrafts
          ?.filter((i) => i?.status)
          ?.every(
            (draft) =>
              draft.postDescription?.length &&
              draft.postDescription !== "<p><br></p>"
          ),
      message: "Please fill in all required fields to continue",
    },
    {
      condition: (props: ValidationProps) =>
        !props.formData.postInfo?.postDrafts
          ?.filter((i) => i?.status)
          ?.every(
            (draft) =>
              draft.postGuidelines?.length &&
              draft.postGuidelines !== "<p><br></p>"
          ),
      message: "Please fill in all required fields to continue",
    },
  ],
};

const HandleValidation = (props: ValidationProps): boolean => {
  const {
    currentStep,
    checkArray,
    setCurrentStep,
    toast,
    setIsLoading,
    generalState,
  } = props;

  const stepsToValidate = new Set<number>();

  if (currentStep === 4) {
    stepsToValidate.add(1);
    stepsToValidate.add(2);
    stepsToValidate.add(4);
  } else if (checkArray?.length) {
    checkArray.forEach((step) => stepsToValidate.add(step));
  } else {
    stepsToValidate.add(currentStep);
  }

  const resetLoading = () => {
    generalState?.setLoading(false);
    setIsLoading(false);
  };
  for (const step of stepsToValidate) {
    const rules = validationRules[step as keyof typeof validationRules];
    if (!rules) continue;

    for (const rule of rules) {
      if (rule.condition(props)) {
        setCurrentStep(step);
        toast({
          title: rule.message,
          variant: "destructive",
        });
        resetLoading();
        return false;
      }
    }
  }
  return true;
};

export default HandleValidation;
